
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$popover.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$popover.js';
export default __default__;
